import closeIcon from '../assets/figma/icon-close.svg';
import infoIcon from '../assets/figma/icon-info.svg';
import styles from '../components/InfoHotspot.module.css';

interface InfoHotspotOptions {
  title: string;
  text: string;
  closeLabel: string;
}

export function createInfoHotspotElement({ title, text, closeLabel }: InfoHotspotOptions): HTMLElement {
  const el = document.createElement('div');
  el.className = styles.hotspot;
  el.innerHTML = `
    <button type="button" class="${styles.ring}" aria-expanded="false">
      <span class="${styles.core}">
        <img class="${styles.icon}" src="${infoIcon}" width="24.0039" height="24" alt="" />
      </span>
    </button>
    <div class="${styles.card}" role="dialog">
      <div class="${styles.header}">
        <img class="${styles.icon}" src="${infoIcon}" width="24.0039" height="24" alt="" />
        <h3 class="${styles.title}"></h3>
        <button type="button" class="${styles.close}">
          <img class="${styles.icon}" src="${closeIcon}" width="24" height="24" alt="" />
        </button>
      </div>
      <div class="${styles.body}">
        <p class="${styles.text}"></p>
      </div>
    </div>
  `;

  const ring = el.querySelector<HTMLButtonElement>(`.${styles.ring}`)!;
  const close = el.querySelector<HTMLButtonElement>(`.${styles.close}`)!;
  el.querySelector(`.${styles.title}`)!.textContent = title;
  el.querySelector(`.${styles.text}`)!.textContent = text;
  ring.setAttribute('aria-label', title);
  close.setAttribute('aria-label', closeLabel);

  const setOpen = (open: boolean) => {
    el.classList.toggle(styles.open, open);
    ring.setAttribute('aria-expanded', String(open));
  };

  ring.addEventListener('click', (e) => {
    e.stopPropagation();
    setOpen(true);
  });
  close.addEventListener('click', (e) => {
    e.stopPropagation();
    setOpen(false);
  });

  return el;
}
